/**
 * Browser-side MSW setup
 * Used in development mode when REACT_APP_ENABLE_MSW=true
 *
 * Usage in index.tsx:
 * if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_ENABLE_MSW === 'true') {
 *   const { worker } = await import('./mocks/browser');
 *   await worker.start();
 * }
 */

import { setupWorker } from 'msw/browser';
import { http, HttpResponse } from 'msw';
import { handlers } from '@/test/msw/handlers';
import endpoints from '@/api/endpoints';

const unmockedApiFallbackHandler = http.all(`${endpoints.baseURL}/*`, ({ request }) => {
  // Block unmocked API calls in browser dev mode to avoid accidental real backend traffic.
  return HttpResponse.json(
    {
      code: 'msw_unmocked_endpoint',
      message: {
        en: `MSW: No mock found for ${request.method} ${request.url}`,
        fr: `MSW: Aucun mock trouve pour ${request.method} ${request.url}`,
      },
    },
    { status: 501 }
  );
});

export const worker = setupWorker(...handlers, unmockedApiFallbackHandler);
